"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayerGroupFactory = void 0;
var LayerGroupCollections_1 = require("./LayerGroupCollections");
var LayerGroupCollection_1 = require("./LayerGroupCollection");
var LayerGroupFactory = /** @class */ (function () {
    function LayerGroupFactory(_vectorLayerGroupFactory, _wmsLayerGroupFactory) {
        var _this = this;
        this._vectorLayerGroupFactory = _vectorLayerGroupFactory;
        this._wmsLayerGroupFactory = _wmsLayerGroupFactory;
        this.getLayerGroups = function (layerGroupCollectionConfig, styleFactory, urlParams) {
            var layerGroupCollections = new Array();
            layerGroupCollectionConfig.forEach(function (groupConfig) {
                var lgCollection = new LayerGroupCollection_1.LayerGroupCollection();
                Object.assign(lgCollection, groupConfig);
                //if (lgCollection.name) {
                //    lgCollection.name = groupConfig.name;
                //}
                //if (lgCollection.description) {
                //    lgCollection.description = groupConfig.description;
                //} 
                //if (lgCollection.allowExpand) {
                //    lgCollection.allowExpand = groupConfig.allowExpand;
                //} 
                //if (lgCollection.alwaysExpandedOnLoad) {
                //    lgCollection.alwaysExpandedOnLoad = groupConfig.alwaysExpandedOnLoad;
                //} 
                //if (lgCollection.expandedOnFirstLoad) {
                //    lgCollection.expandedOnFirstLoad = groupConfig.expandedOnFirstLoad;
                //}             
                groupConfig.layerGroupConfigs.forEach(function (lg) {
                    if (_this.isVectorLayerGroup(lg)) {
                        lgCollection.layerGroups.push(_this._vectorLayerGroupFactory.getLayerGroup(lg, styleFactory, urlParams));
                    }
                    else {
                        lgCollection.layerGroups.push(_this._wmsLayerGroupFactory.getLayerGroup(lg, urlParams));
                    }
                });
                layerGroupCollections.push(lgCollection);
            });
            return new LayerGroupCollections_1.LayerGroupCollections(layerGroupCollections);
        };
        this.isVectorLayerGroup = function (arg) {
            return arg.strategy !== undefined;
        };
    }
    return LayerGroupFactory;
}());
exports.LayerGroupFactory = LayerGroupFactory;
//# sourceMappingURL=LayerGroupFactory.js.map